

































import { Component, Vue } from 'vue-property-decorator';
import Card from '@/components/Card.vue';

@Component({
  components: {
    Card,
  },
  head: {
    title: {
      inner: 'Contact',
    },
  },
  data() {
    return {
      showError: false,
      mailSent: false,
    };
  },
  methods: {
    sendMail() {
      const fullName = (this.$refs.fullName as any).value;
      const emailAddress = (this.$refs.emailAddress as any).value;
      const userMessage = (this.$refs.userMessage as any).value;

      if (fullName && emailAddress && userMessage) {

        // Prepare the message
        const serviceId = 'gmail';
        const templateId = 'website-contact-form';
        const templateParams = {
          from_name: fullName,
          reply_email: emailAddress,
          message_body: userMessage,
        };

        // Send the message
        (window as any).emailjs.init('user_K6F041q1dQvz8SJLSOZCR');
        (window as any).emailjs.send(serviceId, templateId, templateParams);

        // Update the UI
        (this as any).mailSent = true;
      } else {
        // User missed out some fields- don't send email
        (this as any).showError = true;
      }
    },
  },
})
export default class Contact extends Vue {
  public $refs!: {
    fullName: HTMLFormElement,
  };
}
